import React, { useEffect, useRef } from 'react';
import './ChatMessages.scss';
import { ChatMessage } from '../../types';

interface ChatMessagesProps {
  messages: ChatMessage[];
}

/**
 * Component to display chat messages in the AIAnalysis module
 */
const ChatMessages: React.FC<ChatMessagesProps> = ({ messages }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const lastMessageRef = useRef<HTMLDivElement>(null);
  const previousLastMessageRef = useRef<HTMLElement | null>(null);

  // Position the user's message at the top of the viewport when added
  useEffect(() => {
    // Clear margin from previous last message if it exists
    if (previousLastMessageRef.current) {
      previousLastMessageRef.current.style.marginBottom = '';
      previousLastMessageRef.current = null;
    }

    // Apply margin to the latest message and store reference
    const lastMessage = messages[messages.length - 1];
    if (lastMessageRef.current) {
      lastMessageRef.current.style.marginBottom = '50vh';
      previousLastMessageRef.current = lastMessageRef.current;

      // Only scroll if it's a user message
      if (lastMessage && lastMessage.sender === 'user') {
        // Scroll the message into view
        lastMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [messages]);

  return (
    <div className="chat-messages">
      {messages.map((message: ChatMessage, index) => (
        <div
          key={message.id}
          className={`message message--${message.sender}`}
          ref={index === messages.length - 1 ? lastMessageRef : null}
        >
          {message.content}
          <div className="chat-messages__timestamp">{message.timestamp.toLocaleTimeString()}</div>
        </div>
      ))}
      {/* This empty div serves as a scroll anchor */}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatMessages;
